import { Message } from "../../../domain/model/Auth";
import { Answer } from "../../../domain/model/Question";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { AnswerRepository } from "./AnswerRepository";

export class AnswerRepositoryImpl implements AnswerRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }

  getAnswerByQuestionId(questionId: string): Promise<Response<Answer>> {
    return this.apiService.getAnswerByQuestionId(questionId);
  }
  getAnswer(id: string): Promise<Response<Answer>> {
    return this.apiService.getAnswer(id);
  }
}
